<template>
  <svg fill="none" height="18" viewBox="0 0 18 18" width="18">
    <path
      d="M9 5.44444V12.5556M5.44444 9H12.5556M2.77778 1H15.2222C16.2041 1 17 1.79594 17 2.77778V15.2222C17 16.2041 16.2041 17 15.2222 17H2.77778C1.79594 17 1 16.2041 1 15.2222V2.77778C1 1.79594 1.79594 1 2.77778 1Z"
      stroke="currentColor"
      stroke-linecap="round"
      stroke-linejoin="round"
      stroke-width="2"
    />
  </svg>
</template>

<script>
  export default {
    name: 'CreateIcon',
  };
</script>
